import { SELECTION_CAP } from 'areas/search/hooks';
import { faCancel, faShareSquare } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { AssignCaseworkerCourseDialog } from '../modals/assign-caseworker-for-course/assign-caseworker-for-course';
import { ConfirmCompleteCoursesDialog } from '../modals/confirm-complete-courses-dialog/confirm-complete-courses-dialog';

export const actions: IAction[] = [
  {
    context: 'Courses',
    id: 'CourseAssignTeamOrUser',
    displayName: 'Tildel',
    icon: faShareSquare,
    action: selectedEntries => <AssignCaseworkerCourseDialog courseIds={selectedEntries} />,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
  },
  {
    context: 'Courses',
    id: 'CompleteCourses',
    displayName: 'Afslut hold',
    icon: faCancel,
    action: selectedEntries => <ConfirmCompleteCoursesDialog courseIds={selectedEntries} />,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
  },
];
